<template>
    <div>
        <div class="row" style="margin-bottom: 0;">
            <div class="col s12 offset-m2 m8 offset-l3 l6 offset-xl3 xl6">
                <h5 class="center-align white-text">
                    Редактирование данных администратора "{{user.login}}"
                </h5>
            </div>
        </div>
        <div class="row">
            <div class="col s12 offset-m2 m8 offset-l2 l8 offset-xl2 xl8">
                <table class="highlight card bg"
                       :data-login="user.login"
                       :data-id="user.id">
                    <tbody>
                    <tr>
                        <td colspan="2" class="row">
                            <a @click="$router.push('/admins')"
                               style="width: 50px;"
                               class="btn grey darken-3 waves-effect
									    waves-light btn-small col s12 m5 l5 xl5 right">
                                <i class="material-icons">keyboard_backspace</i>
                            </a>
                        </td>
                    </tr>
                    <tr :key="user.id">
                        <td>логин</td>
                        <td>{{user.login}}</td>
                    </tr>
                    <tr>
                        <td>заметка</td>
                        <td>
                            <div class="input-field col s12 m12 l12 offset-xl2 xl10">
										<textarea id="textarea1"
                                                  class="materialize-textarea"
                                                  v-model="user.note">
										</textarea>
                                <label for="textarea1"></label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>включен</td>
                        <td>
                            <label>
                                <input type="checkbox"
                                       v-model="user.enabled"/>
                                <span></span>
                            </label>
                        </td>
                    </tr>
                    <tr>
                        <td>только чтение</td>
                        <td>
                            <label>
                                <input type="checkbox"
                                       v-model="user.read_only"/>
                                <span></span>
                            </label>
                        </td>
                    </tr>
                    <tr>
                        <td>root</td>
                        <td>
                            <label>
                                <input type="checkbox"
                                       v-model="user.is_root"/>
                                <span></span>
                            </label>
                        </td>
                    </tr>
                    <tr>
                        <td>телефон</td>
                        <td>
                            <div class="input-field col s12 m12 l12 offset-xl2 xl8">
                                <input type="text"
                                       id="autocomplete-phone"
                                       v-model="user.phone"
                                       autocomplete="off"
                                       class="autocomplete">
                                <label for="autocomplete-phone"></label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>пароль</td>
                        <td class="tooltipped darken-3 bold">
                            <div class="input-field col s12 m12 l12 offset-xl2 xl8">
                                <input type="password"
                                       id="autocomplete-pass"
                                       @keyup="setPass($event)"
                                       @blur="blur"
                                       v-model.lazy="pass"
                                       :class="((user.pass !== user.confirmPass)
									                        && ($v.confirmPass.$dirty && $v.pass.$dirty))
									                        ?
									                        'error'
									                        : null"
                                       autocomplete="off"
                                       class="autocomplete">
                                <label for="autocomplete-pass"></label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>подтверждение пароля</td>
                        <td class="tooltipped darken-3 bold">
                            <div class="input-field col s12 m12 l12  offset-xl2 xl8">
                                <input type="password"
                                       id="autocomplete-confirm-pass"
                                       @keyup="setConfirmPass($event)"
                                       @blur="blur"
                                       v-model.lazy="confirmPass"
                                       :class="((user.pass !== user.confirmPass)
									                        && ($v.confirmPass.$dirty && $v.pass.$dirty))
								                            ?
								                            'error'
									                        : null"
                                       autocomplete="off"
                                       class="autocomplete">
                                <label for="autocomplete-confirm-pass"></label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="row"
                            colspan="2">
                            <a class="btn indigo lighten-1 waves-effect waves-light btn-small col s12 m5 l5 xl5"
                               style="margin: 5px 0;"
                               @click="$router.push(`/users/adminsBuildings?user=${user.login}&buildings=${JSON.stringify(user.buildings)}`)">
                                <i class="material-icons left">domain</i>
                                список домов - {{user.buildings ? user.buildings.length : "нет"}}
                            </a>
                            <div class="col hide-on-small-only m2 l2 xl2"></div>
                            <a @click="save"
                               style="margin: 5px 0;"
                               :class="{disabled: (user.pass !== user.confirmPass)
					                        && ($v.confirmPass.$dirty && $v.pass.$dirty)}"
                               class="btn teal lighten-1 waves-effect
									    waves-light btn-small width-btn col s12 m5 l5 xl5">
                                <i class="material-icons left"
                                >save</i>
                                Сохранить</a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import admins from "../../plugins/controllers/admins";
    import setRules from "../../assets/setRules";
    import {eventEmitter} from "../../main";
    import {mapState, mapMutations} from "vuex";
    //import swal                       from "sweetalert";
    import swal from "sweetalert2";
    import preload from "../../assets/preload";

    export default {
        name: "EditAdmins",
        data() {
            return {
                pass: "",
                confirmPass: "",
                user: {
                    buildings: [],
                    enabled: null,
                    id: null,
                    is_root: null,
                    login: "",
                    mail: "",
                    note: "",
                    pass: null,
                    confirmPass: null,
                    phone: null,
                    read_only: null,
                    validated: null
                }
            };
        },
        validations: {
            pass: {},
            confirmPass: {}
        },
        beforeMount() {
            eventEmitter.$once("tokenSuccess", this.getAdmin);
        },
        beforeDestroy() {
            eventEmitter.$off("tokenSuccess", this.getAdmin);
        },
        mounted() {
            if (this.tokenSuccess) {
                this.getAdmin();
            } else {
                console.log("token is not success");
            }
        },
        computed: {
            ...mapState(["tokenSuccess"])
        },
        methods: {
            ...mapMutations(["setAuth", "setShowMenu"]),
            save() {

                if (this.confirmPass === ""
                    || this.user.confirmPass === null
                    || this.user.confirmPass === undefined
                    || this.user.confirmPass === 0) {
                    this.user.confirmPass = null;
                }
                let savedUser = {
                    login: this.user.login,
                    pass: this.user.confirmPass,
                    note: this.user.note,
                    enabled: this.user.enabled,
                    read_only: this.user.read_only,
                    is_root: this.user.is_root,
                    phone: this.user.phone,
                    validated: this.user.validated,
                    buildings: this.user.buildings
                };
                console.log(savedUser);
                let swalOptions = {
                    title: 'Сохранить изменения?',
                    text: "Пароль не будет изменен!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'Отмена',
                    confirmButtonText: 'Сохранить!'
                };
                if (this.user.confirmPass !== null && (this.pass === "")) {
                    swalOptions.text = "Пароль будет изменен!"
                }
                swal.fire(swalOptions).then((result) => {
                    if (result.value) {
                        admins.updateAdmin(savedUser)
                            .then((res) => {
                                setRules(res);
                                this.$router.push("/admins");
                                this.$toast.success({
                                    title: "Изменения успешно сохранены",
                                    message: "Можете продолжить редактирование"
                                });
                            })
                            .catch(e => {
                                console.log(e);
                                this.setAuth(true);
                                this.setShowMenu(false);
                                this.$toast.error({
                                    title: "Не удалось cохранить изменения",
                                    message: "Свяжитесь с администратором сервиса"
                                });
                            });
                    }
                })
            },
            setPass(event) {
                this.pass = event.target.value;
                this.$v.pass.$touch();
            },
            setConfirmPass(event) {
                if (event.target.value === "") {
                    this.$v.confirmPass.$reset();
                } else {
                    this.$v.confirmPass.$touch();
                }
                this.confirmPass = event.target.value;
            },
            blur() {
                if (this.$v.confirmPass.$dirty && this.$v.pass.$dirty) {
                    this.user.pass = this.pass;
                    this.user.confirmPass = this.confirmPass;
                }
            },
            getAdmin() {
                // preload.show();
                admins.getAdminByLogin(this.$route.params.login)
                    .then(res => {
                        setRules(res);
                        console.log(res);
                        this.user.buildings = res.data.buildings;
                        this.user.enabled = res.data.enabled;
                        this.user.id = res.data.id;
                        this.user.is_root = res.data.is_root;
                        this.user.login = res.data.login;
                        this.user.note = res.data.note;
                        this.user.phone = res.data.phone;
                        this.user.read_only = res.data.read_only;
                        this.user.validated = res.data.validated;
                    })
                    .catch(e => {
                        this.setAuth(true);
                        if (e.message.toLowerCase() === "network error") {
                            this.$toast.error({
                                title: "Ошибка с соединением",
                                message: "Проблемы с интернет-подключением или с доступом к серверу"
                            });
                        } else {
                            this.$toast.error({
                                title: "Произошла ошибка",
                                message: "Авторизуйтесь с вашей учетной записи"
                            });
                        }
                    })
                    .then(() => {
                        // preload.hidden();
                    });

            }
        }
    };
</script>
<style scoped lang="scss">
    .bold {
        font-weight: 500;
    }

    @media screen and (max-width: 600px) {
        h5 {
            font-size: 16px;
            margin-bottom: 0;
        }
    }

    .bg {
        background-color: rgba(56, 56, 56, 0.8);
    }

    input[type="password"] {
        transition: all 0.3s
    }

    input[type="password"].error {
        color: #c62828;
        border-bottom: 1px solid #c62828;
        box-shadow: 0 1px 0 #c62828;

        &:not(.browser-default):focus:not([readonly]) {
            border-bottom: 1px solid #c62828;
            box-shadow: 0 1px 0 #c62828;
        }

        &:not(.browser-default):focus:not([readonly]) + label {
            color: #c62828;
        }
    }

    textarea, input {

        color: #fff;
        transition: all 0.3s;
    }

    textarea:not(.browser-default):focus:not([readonly]) {
        &:not(.browser-default):focus:not([readonly]) {
            border-bottom: 1px solid #4d5ff1;
            box-shadow: 0 1px 0 #4c5edf;
        }

        &:not(.browser-default):focus:not([readonly]) + label {
            color: #4d5ff1;
        }
    }

    input[type="password"], input[type="text"] {
        &:not(.browser-default):focus:not([readonly]) {
            border-bottom: 1px solid #4d5ff1;
            box-shadow: 0 1px 0 #4c5edf;
        }

        &:not(.browser-default):focus:not([readonly]) + label {
            color: #4d5ff1;
        }
    }

    [type="checkbox"]:checked + span:not(.lever):before {
        border: 2px solid transparent;
        border-right-color: white;
        border-bottom-color: white;
    }

    [type="checkbox"] + span:not(.lever):before {
        border: 2px solid white;
    }

    .parallax-container {
        height: auto;
    }

    table.highlight > tbody > tr > td {
        padding: 7px 10px;
        font-size: 14px;
    }

    table.highlight > tbody > tr > td:first-child {
        padding-left: 12px;
    }

    table.highlight > tbody > tr:hover {
        background-color: rgba(36, 37, 40, 0.51);
    }

    .input-field {
        padding-right: 0;
        margin: 0;
    }

    tr td:first-child {
        width: 20%;
        font-weight: 600;
        text-transform: uppercase;
    }

    tr td:last-child {
        text-align: center;
    }

    .width-btn {
        margin: 10px;
    }
</style>
